import b64toBlob from "b64-to-blob";
import * as XLSX from 'xlsx';
import excelColumnName from 'excel-column-name';

import { cloneArray, func_validation, isArrayNotEmpty } from "./func_validation";
import { func_url } from "./func_url";

export const func_file = {

    getMediaType_PDF,
    getMediaType_XLSX,
    getMediaType_CSV,
    getMediaType_PNG,
    getMediaType_JPG,
    getMediaType_JPEG,

    getBase64Extension,

    generateDataURI_nonData,
    generateDataURI_nonData_PDF,
    generateDataURI_nonData_XLSX,
    generateDataURI_nonData_CSV,
    generateDataURI_nonData_PNG,
    generateDataURI_nonData_JPG,
    generateDataURI_nonData_JPEG,

    isNameContainsFileExtension,

    getFileExtensionType_PDF,
    getFileExtensionType_XLSX,
    getFileExtensionType_CSV,
    getFileExtensionType_PNG,
    getFileExtensionType_JPG,
    getFileExtensionType_JPEG,

    extractMediaTypeFromDataURI,
    extractBase64FromDataURI,
    
    generateEncodedDataURI,
    encodeDataURI_PDF,
    encodeDataURI_XLSX,
    encodeDataURI_CSV,
    encodeDataURI_PNG,
    encodeDataURI_JPG,
    encodeDataURI_JPEG,

    convertBase64stringToBlob,
	convertFileToBase64string,
	
	setupPromiseFileReader,
	convertPromiseMultipleFilesToBase64string,
	getPromiseBase64stringFileInputData,

    openFileInNewTab,
    openFileInNewTab_PDF,
    openFileInNewTab_PNG,
    openFileInNewTab_JPG,
    openFileInNewTab_JPEG,

    openFileInNewTabFromUnknowMediaType,

    openLinkInNewTab,

    readUploadedFile_XLSX,
    generateFile_XLSX,
    getXLSXColumnName,
    getXLSXColumnIndex,

    downloadFile,
    downloadFile_PDF,
    downloadFile_XLSX,
    downloadFile_CSV,
    downloadFile_PNG,
    downloadFile_JPG,
    downloadFile_JPEG,

    downloadFile_base64_PDF,
    downloadFile_base64_XLSX,
    downloadFile_base64_CSV,
    downloadFile_base64_PNG,
    downloadFile_base64_JPG,
    downloadFile_base64_JPEG,

    downloadDataURIFromUnknowMediaType,
    
    openLinkInCurrentTabToDownloadURI,

    isSourceTypeLink,
    isSourceTypeDataURI,
    
    downloadFromUnknownSourceType,
    openInNewTabFromUnknownSourceType,

	createAndRunSelfExecutingForm,

	copyTextToClipboard,

    dataURIChecker,
    isDataURI_PDF,
    isDataURI_XLSX,
    isDataURI_CSV,
    isDataURI_Img,
    isDataURI_Img_PNG,
    isDataURI_Img_JPG,
    isDataURI_Img_JPEG,

    isMediaType_PDF,
    isMediaType_XLSX,
    isMediaType_CSV,
	isMediaType_Img,
    isMediaType_Img_PNG,
    isMediaType_Img_JPG,
	isMediaType_Img_JPEG,

    fileTypeChecker,
    isFileType_PDF,
    isFileType_XLSX,
    isFileType_CSV,
	isFileType_Img,
    isFileType_Img_PNG,
    isFileType_Img_JPG,
	isFileType_Img_JPEG,

	getValidatedFileExtension,

};

function getMediaType_PDF() { return "application/pdf"; }

function getMediaType_XLSX() { return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; }

function getMediaType_CSV() { return "text/csv"; }

function getMediaType_PNG() { return "image/png"; }

function getMediaType_JPG() { return "image/jpg"; }

function getMediaType_JPEG() { return "image/jpeg"; }

function getBase64Extension() { return ";base64"; }

function generateDataURI_nonData(mediaType) {
    if (func_validation.isStringTrimNotEmpty(mediaType))
        return ("data:" + mediaType + getBase64Extension() + ",");
    return "";
}

function generateDataURI_nonData_PDF() {
    return generateDataURI_nonData(getMediaType_PDF()); 
}

function generateDataURI_nonData_XLSX() { 
    return generateDataURI_nonData(getMediaType_XLSX()); 
}

function generateDataURI_nonData_CSV() { 
    return generateDataURI_nonData(getMediaType_CSV()); 
}

function generateDataURI_nonData_PNG() { 
    return generateDataURI_nonData(getMediaType_PNG()); 
}

function generateDataURI_nonData_JPG() { 
    return generateDataURI_nonData(getMediaType_JPG()); 
}

function generateDataURI_nonData_JPEG() { 
    return generateDataURI_nonData(getMediaType_JPEG()); 
}

function isNameContainsFileExtension(fileName, fileExtension) {
    if (func_validation.isStringTrimNotEmpty(fileExtension)) {
        let fileExtension_startPos = fileName.length - fileExtension.length;
        let fileName_fileExtension = fileName.substring(fileExtension_startPos);
    
        return (func_validation.isStringEqual_caseInsensitive(fileName_fileExtension, fileExtension));
    }
    return false;
}

function getFileExtensionType_PDF() { return ".pdf"; }

function getFileExtensionType_XLSX() { return ".xlsx"; }

function getFileExtensionType_CSV() { return ".csv"; }

function getFileExtensionType_PNG() { return ".png"; }

function getFileExtensionType_JPG() { return ".jpg"; }

function getFileExtensionType_JPEG() { return ".jpeg"; }

function extractMediaTypeFromDataURI(dataURI) {
    if (func_validation.isStringTrimNotEmpty(dataURI) &&
        (dataURI.indexOf(":") != -1)) {

        let startPos = dataURI.indexOf(":") + 1;
        let endPos = dataURI.indexOf(",");
        if ((dataURI.indexOf(";") != -1)) endPos = dataURI.indexOf(";");

        if ((startPos < dataURI.length) &&
            (endPos < dataURI.length)) return dataURI.substring(startPos, endPos);
    }
    return dataURI;
}

function extractBase64FromDataURI(dataURI) {
    // Has both the URI and base64
    if (func_validation.isStringTrimNotEmpty(dataURI)) {
        let seperatorPos = dataURI.indexOf(",");
        if (seperatorPos != -1 &&
            ((seperatorPos + 1) < dataURI.length)) return dataURI.substring(seperatorPos + 1);
    }
    return dataURI; // only has base64
}

function generateEncodedDataURI(mediaType, base64) { 
    if (func_validation.isStringTrimNotEmpty(base64) &&
        func_validation.isStringTrimNotEmpty(mediaType))
        return (generateDataURI_nonData(mediaType) + base64); 
    return "";
}

function encodeDataURI_PDF(base64) {
    return generateEncodedDataURI(getMediaType_PDF(), base64);
}

function encodeDataURI_XLSX(base64) {
    return generateEncodedDataURI(getMediaType_XLSX(), base64);
}

function encodeDataURI_CSV(base64) {
    return generateEncodedDataURI(getMediaType_CSV(), base64);
}

function encodeDataURI_PNG(base64) {
    return generateEncodedDataURI(getMediaType_PNG(), base64);
}

function encodeDataURI_JPG(base64) {
    return generateEncodedDataURI(getMediaType_JPG(), base64);
}

function encodeDataURI_JPEG(base64) {
    return generateEncodedDataURI(getMediaType_JPEG(), base64);
}

function convertBase64stringToBlob(dataURI, mediaType) {
    // Check for Full Base64 URI     
    if (func_validation.isStringTrimNotEmpty(dataURI) && 
        func_validation.isStringTrimNotEmpty(mediaType))
        return b64toBlob(extractBase64FromDataURI(dataURI), mediaType);
    return undefined;
}

function convertFileToBase64string(ele, callbackFunc) {
    // Read File
    if (func_validation.isNotNullUndefined(ele)) {
        let selectedFile = ele.files;

        // Check File is not Empty
        if (selectedFile.length > 0) {
            // Select the very first file from list
            let fileToLoad = selectedFile[0];
            
            // FileReader function for read the file.
            let fileReader = new FileReader();

            // Onload of file read the file content
            fileReader.onload = function(fileLoadedEvent) {
                let base64 = fileLoadedEvent.target.result;
                if (callbackFunc) callbackFunc(fileToLoad.name, base64);
            };

            // Convert data to base64
            fileReader.readAsDataURL(fileToLoad);
        }
    }
}

function setupPromiseFileReader(file) {
	return new Promise((resolve, reject) => {

		// File Reader
		let fileReader = new FileReader();
		
		// Resolve on FileReader Load
		fileReader.onload = function(fileLoadedEvent) {
			resolve({ 
				fileName: file.name, 
				fileType: file.type,
				fileSize: file.size,
				
				fileLastModified: file.lastModified,
				fileLastModifiedDate: file.lastModifiedDate,

				base64: fileLoadedEvent.target.result,
			});
		};

		// Reject on FileReader error/abort
        fileReader.onerror = fileReader.onabort = reject;

		// Convert data to base64 through fileReader
		fileReader.readAsDataURL(file);
	});
}

function convertPromiseMultipleFilesToBase64string(filesArray) {
	return Promise.all(filesArray.map(setupPromiseFileReader));
}

function getPromiseBase64stringFileInputData(ele, opts) {
	let maxFiles = func_validation.getObjectPropertyValue(opts, "maxFiles");
	let isMaxPartialReject = func_validation.getObjectPropertyValue(opts, "partialReject", false);
	
	// Read File
	if (func_validation.isNotNullUndefined(ele)) {

		// File Data
		let selectedFiles = ele.files;
		let selectedFilesArray = Array.from(selectedFiles);
		let totalSelectedFiles = selectedFiles.length;

		if (func_validation.isNotNullUndefined(maxFiles)) {
			if (!func_validation.isNumberWithinRange(totalSelectedFiles, { max: maxFiles })) {
				
				// Handle when total selected files is over maxFiles
				// - default complete reject if over maxFiles
				if (isMaxPartialReject) {
					return convertPromiseMultipleFilesToBase64string(selectedFilesArray.slice(0, maxFiles));
				} else return Promise.reject([]);
				
			} else return convertPromiseMultipleFilesToBase64string(selectedFilesArray);
		} else return convertPromiseMultipleFilesToBase64string(selectedFilesArray);
	} else return Promise.reject([]);
}


function openFileInNewTab(fileName, dataURI, mediaType, fileExtension, encodeDataURIFunc) {
    if (func_validation.isStringTrimNotEmpty(dataURI)) {
        let tB = convertBase64stringToBlob(dataURI, mediaType);
        let tF = (func_validation.isStringTrimNotEmpty(fileName))?fileName:"untitled";
        if (!isNameContainsFileExtension(tF, fileExtension)) tF += fileExtension;

        if (tB) {
            if(window.top.navigator.msSaveOrOpenBlob){
                //Store Blob in IE
                window.top.navigator.msSaveOrOpenBlob(tB, tF);
            } else {
                var w = window.open("about:blank");
                setTimeout(function() { //FireFox seems to require a setTimeout for this to work.
                    let targetIframe = w.document.createElement("iframe");
                    let base64 = extractBase64FromDataURI(dataURI);
                    targetIframe.src = encodeDataURIFunc(base64);
        
                    // Iframe css properties
                    targetIframe.style.width = "100%";
                    targetIframe.style.height = "100vh";
                    targetIframe.style.position = "fixed";
                    targetIframe.style.top = "0px";
                    targetIframe.style.left = "0px";
                    targetIframe.style.border = "none";
        
                    w.document.body.appendChild(targetIframe);
                }, 0);
            }
        }
    }
}

function openFileInNewTab_PDF(fileName, dataURI) {
    openFileInNewTab(fileName, dataURI, getMediaType_PDF(), getFileExtensionType_PDF(), encodeDataURI_PDF);
}

function openFileInNewTab_PNG(fileName, dataURI) {
    openFileInNewTab(fileName, dataURI, getMediaType_PNG(), getFileExtensionType_PNG(), encodeDataURI_PNG);
}

function openFileInNewTab_JPG(fileName, dataURI) {
    openFileInNewTab(fileName, dataURI, getMediaType_JPG(), getFileExtensionType_JPG(), encodeDataURI_JPG);
}

function openFileInNewTab_JPEG(fileName, dataURI) {
    openFileInNewTab(fileName, dataURI, getMediaType_JPEG(), getFileExtensionType_JPEG(), encodeDataURI_JPEG);
}

function openFileInNewTabFromUnknowMediaType(fileName, dataURI) {
    if (func_validation.isStringTrimNotEmpty(dataURI)) {
        let mediaType = extractMediaTypeFromDataURI(dataURI);
        if (isMediaType_PDF(mediaType)) openFileInNewTab_PDF(fileName, dataURI);
        if (isMediaType_Img_PNG(mediaType)) openFileInNewTab_PNG(fileName, dataURI);
        if (isMediaType_Img_JPG(mediaType)) openFileInNewTab_JPG(fileName, dataURI);
        if (isMediaType_Img_JPEG(mediaType)) openFileInNewTab_JPEG(fileName, dataURI);
    }
}

function openLinkInNewTab(link) {
    if (func_validation.isStringTrimNotEmpty(link)) window.open(link);
}

function readUploadedFile_XLSX(e, sheetNo, callbackFunc, isEmptyColumnIncluded) {
    let sheetNo_formatted = func_validation.isNumberValid(sheetNo)? sheetNo:0;

    let target = func_validation.getObjectPropertyValue(e, "target");
    let files = func_validation.getObjectPropertyValue(target, "files", []);

    // File required
    if (func_validation.isObjectEmpty(files) || 
        (!func_validation.isFunction(callbackFunc))) return;

    let firstFile = files[0];

    let reader = new FileReader();
    reader.onload = function(e) {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, {type: 'array'});

        // Handle Workbook
        let sheetNames = func_validation.getObjectPropertyValue(workbook, "SheetNames");
        var sheetName = func_validation.isArrayNotEmpty(sheetNames)? sheetNames[sheetNo_formatted]:"";

        // Get worksheet
        let sheets = func_validation.getObjectPropertyValue(workbook, "Sheets");
        var worksheet = func_validation.isObjectNotEmpty(sheets)? sheets[sheetName]:{};

        let dataArray = [];
        if (func_validation.isObjectNotEmpty(worksheet)) {
            let headersObj = {};
            let columnNo = 0;
            let record = {};
            let currentRow = 2;
            for (const cell in worksheet) {
                let matches = cell.match(/(\d+)/);
                let columnPos = cell.match(/[A-Z]+/);
                let rowNo = func_validation.isArrayNotEmpty(matches)? matches[0]:undefined;

                // Get Headers
                if (rowNo == 1) {
                    let cellObj = worksheet[cell];
                    let headerName = cellObj["v"]
                    headersObj[columnPos] = func_validation.getTrimmedString(headerName);
                }
                // Build Records
                else if (rowNo) {
                    if (func_validation.isNotNullUndefined(rowNo) &&
                        rowNo != currentRow) {
                        dataArray.push(record);
                        columnNo = 0;
                        record = {};
                        currentRow = rowNo;
                    }

                    // Initialize record
                    if (func_validation.isObjectEmpty(record) && isEmptyColumnIncluded) {
                        for (let property in headersObj) {
                            if (headersObj.hasOwnProperty(property)) {
                                record[headersObj[property]] = "";
                            }
                        }
                    }

                    let cellObj = worksheet[cell];
                    let cellValue = cellObj["v"];

                    // TEMPORARY
                    // Need proper method to detect with datetime
                    if (func_validation.isStringEqual_caseSensitive("LastBilledDateTime", headersObj[columnPos]) ||
                        func_validation.isStringEqual_caseSensitive("NextBilledDateTime", headersObj[columnPos])) {

                        cellValue = cellObj["w"];
                    }

                    record[headersObj[columnPos]] = cellValue;
                    record["rowNo"] = rowNo;
                    columnNo++;
                }
                // Store Record
                else if (func_validation.isObjectNotEmpty(record)) {
                    dataArray.push(record);
                }
            }
        }

        callbackFunc(dataArray);
    };
    reader.readAsArrayBuffer(firstFile);
}

function generateFile_XLSX(fileName, sheetName, headers, rowsData, rowsLabels, mergedCells, columnWidths) {
    // Make worksheet
    var ws_data = [];
    if (func_validation.isArrayNotEmpty(headers)) {
        headers.map((header) => {
            if (isArrayNotEmpty(header)) ws_data.push(header);
        })
    }

    // Note: "rowsData" variable is an array of objects.
    if (func_validation.isArrayNotEmpty(rowsData)) {
        rowsData.map((rowDetailArray, idx) => {
            if (func_validation.isArrayNotEmpty(rowDetailArray)) {
                let array_copy = cloneArray(rowDetailArray);

                if (isArrayNotEmpty(rowsLabels)) {
                    let columnLabels = rowsLabels[idx];
                    if (isArrayNotEmpty(columnLabels))
                        array_copy = [...columnLabels, ...array_copy];
                }
                
                // Add row into sheet
                ws_data.push(array_copy);
            }
        });
    }
    
    var ws = XLSX.utils.aoa_to_sheet(ws_data);

    // Add the merge cells
    ws["!merges"] = mergedCells;

    // Set column widths
    ws['!cols'] = columnWidths;

    // Create a new blank workbook
    var wb = XLSX.utils.book_new();
    
    // Add the worksheet to the workbook
    let sheetName_formatted = func_validation.isStringTrimNotEmpty(sheetName)? sheetName:"Sheet";
    XLSX.utils.book_append_sheet(wb, ws, sheetName_formatted);

    //  Output format determined by filename
    let fileName_formatted = func_validation.isStringTrimNotEmpty(fileName)? fileName: "Download";
    XLSX.writeFile(wb, fileName_formatted + '.xlsx');

    /* at this point, the excel file will have been downloaded */
}

function getXLSXColumnName(columnIndex) {
    if (func_validation.isNumberValid(columnIndex))
        return excelColumnName.intToExcelCol(columnIndex);
    return "";
}

function getXLSXColumnIndex(columnName) {
    if (func_validation.isStringTrimNotEmpty(columnName))
        return excelColumnName.excelColToInt(columnName);
    return undefined;
}

function downloadFile(fileName, dataURI, mediaType, fileExtension) {
    if (func_validation.isStringTrimNotEmpty(dataURI)) {
        let tB = convertBase64stringToBlob(dataURI, mediaType);
        let tF = (func_validation.isStringTrimNotEmpty(fileName))?fileName:"untitled";
        if (!isNameContainsFileExtension(tF, fileExtension)) tF += fileExtension;

        if (tB) {
            if(window.top.navigator.msSaveOrOpenBlob) {
                //Store Blob in IE
                window.top.navigator.msSaveOrOpenBlob(tB, tF);
            } else {
                var tA = document.body.appendChild(document.createElement("a"));
                tA.href = URL.createObjectURL(tB);
                tA.download = tF;
                tA.style.display = "none";
                tA.click();
                tA.parentNode.removeChild(tA);
            }
        }
    }
}

function downloadFile_PDF(fileName, dataURI) {
    downloadFile(fileName, dataURI, getMediaType_PDF(), getFileExtensionType_PDF());
}

function downloadFile_XLSX(fileName, dataURI) {
    downloadFile(fileName, dataURI, getMediaType_XLSX(), getFileExtensionType_XLSX());
}

function downloadFile_CSV(fileName, dataURI) {
    downloadFile(fileName, dataURI, getMediaType_CSV(), getFileExtensionType_CSV());
}

function downloadFile_PNG(fileName, dataURI) {
    downloadFile(fileName, dataURI, getMediaType_PNG(), getFileExtensionType_PNG());
}

function downloadFile_JPG(fileName, dataURI) {
    downloadFile(fileName, dataURI, getMediaType_JPG(), getFileExtensionType_JPG());
}

function downloadFile_JPEG(fileName, dataURI) {
    downloadFile(fileName, dataURI, getMediaType_JPEG(), getFileExtensionType_JPEG());
}

function downloadFile_base64_PDF(fileName, base64) {
    let dataURI = generateDataURI_nonData_PDF() + base64;
    downloadFile(fileName, dataURI, getMediaType_PDF(), getFileExtensionType_PDF());
}

function downloadFile_base64_XLSX(fileName, base64) {
    let dataURI = generateDataURI_nonData_XLSX() + base64;
    downloadFile(fileName, dataURI, getMediaType_XLSX(), getFileExtensionType_XLSX());
}

function downloadFile_base64_CSV(fileName, base64) {
    let dataURI = generateDataURI_nonData_CSV() + base64;
    downloadFile(fileName, dataURI, getMediaType_CSV(), getFileExtensionType_CSV());
}

function downloadFile_base64_PNG(fileName, base64) {
    let dataURI = generateDataURI_nonData_PNG() + base64;
    downloadFile(fileName, dataURI, getMediaType_PNG(), getFileExtensionType_PNG());
}

function downloadFile_base64_JPG(fileName, base64) {
    let dataURI = generateDataURI_nonData_JPG() + base64;
    downloadFile(fileName, dataURI, getMediaType_JPG(), getFileExtensionType_JPG());
}

function downloadFile_base64_JPEG(fileName, base64) {
    let dataURI = generateDataURI_nonData_JPEG() + base64;
    downloadFile(fileName, dataURI, getMediaType_JPEG(), getFileExtensionType_JPEG());
}

function downloadDataURIFromUnknowMediaType(fileName, dataURI) {
    if (func_validation.isStringTrimNotEmpty(dataURI)) {
        let mediaType = extractMediaTypeFromDataURI(dataURI);
        if (isMediaType_PDF(mediaType)) downloadFile_PDF(fileName, dataURI);
        if (isMediaType_XLSX(mediaType)) downloadFile_XLSX(fileName, dataURI);
        if (isMediaType_CSV(mediaType)) downloadFile_CSV(fileName, dataURI);
        if (isMediaType_Img_PNG(mediaType)) downloadFile_PNG(fileName, dataURI);
        if (isMediaType_Img_JPG(mediaType)) downloadFile_JPG(fileName, dataURI);
        if (isMediaType_Img_JPEG(mediaType)) downloadFile_JPEG(fileName, dataURI);
    }
}

function openLinkInCurrentTabToDownloadURI(url, fileName, fileType) {
	let link = document.createElement("a");
	link.href = url;

	if (fileName) link.download = fileName;
	if (fileType) link.type = fileType;

	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

function isSourceTypeLink(source) {
    let uriScheme_http = "http:";
    let uriScheme_https = "https:";
    let uriScheme_blob = "blob:";

    if (func_validation.isStringTrimNotEmpty(source) &&
        func_validation.isStringEqual_caseInsensitive(source.substring(0, uriScheme_http.length), "http:") ||
        func_validation.isStringEqual_caseInsensitive(source.substring(0, uriScheme_https.length), "https:") ||
        func_validation.isStringEqual_caseInsensitive(source.substring(0, uriScheme_blob.length), "blob:")) return true;
    return false;
}

function isSourceTypeDataURI(source) {
    let uriScheme_data = "data:";

    if (func_validation.isStringTrimNotEmpty(source) &&
        func_validation.isStringEqual_caseInsensitive(source.substring(0, uriScheme_data.length), "data:")) return true;
    return false;
}

function downloadFromUnknownSourceType(fileName, source) {
    if (isSourceTypeDataURI(source)) {
        downloadDataURIFromUnknowMediaType(fileName, source);
    }
    else if (isSourceTypeLink(source)) {
        openLinkInCurrentTabToDownloadURI(source, fileName);
    }
}

function openInNewTabFromUnknownSourceType(fileName, source) {
    if (isSourceTypeDataURI(source)) {
        openFileInNewTabFromUnknowMediaType(fileName, source);
    }
    else if (isSourceTypeLink(source)) {
        openLinkInNewTab(source);
    }
}

function createAndRunSelfExecutingForm(url, method, formData) {
	let form = document.createElement("form");
	form.action = (url)?url:"";
	form.method = (method)?method:"POST";

	if (func_validation.isObjectNotEmpty(formData)) {
		Object.keys(formData).map((formInputName)=>{
			let name = formInputName;
			let val = formData[formInputName];

			if (func_validation.isStringTrimNotEmpty(val)) {
				let inputEle = document.createElement("input"); 

				inputEle.name = name;
				inputEle.type = "hidden";
				inputEle.value = val;
	
				form.appendChild(inputEle);  
			}
		});
		
		document.body.appendChild(form);

		form.submit();
	}
}

function copyTextToClipboard(text) {
	
	// Create Input and set value
	let textArea = document.createElement("textarea");
	textArea.value = text;
	document.body.appendChild(textArea);

	// Support for iOS
	if (func_url.checkIsIOS()) {

		// Save old values before overwriting
		let oldContentEditable = textArea.contentEditable;
		let oldReadOnly = textArea.readOnly;
		textArea.contentEditable = true;
		textArea.readOnly = true;

		// Create Range
		let range = document.createRange();
		range.selectNodeContents(textArea);

		// Select Content
		let selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange(range);
		textArea.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

		// Reset to old values
		textArea.contentEditable = oldContentEditable;
		textArea.readOnly = oldReadOnly;

	}
	else {
		textArea.select();
	}

	// Copy Content
	document.execCommand("Copy");
	
	// Remove input
	textArea.remove();
}

function dataURIChecker(dataURI, dataURI_nonData) {
    if (func_validation.isStringTrimNotEmpty(dataURI) && 
        ~dataURI.indexOf(dataURI_nonData)) 
        return true;
    return false;
}

function isDataURI_PDF(dataURI) {
    return dataURIChecker(dataURI, generateDataURI_nonData_PDF());
}

function isDataURI_XLSX(dataURI) {
    return dataURIChecker(dataURI, generateDataURI_nonData_XLSX());
}

function isDataURI_CSV(dataURI) {
    return dataURIChecker(dataURI, generateDataURI_nonData_CSV());
}

function isDataURI_Img(dataURI) {
    if (func_validation.isStringTrimNotEmpty(dataURI) && 
        (isDataURI_Img_JPG(dataURI) || 
         isDataURI_Img_JPEG(dataURI) ||  
         isDataURI_Img_PNG(dataURI)) )
        return true;
    return false;
}

function isDataURI_Img_PNG(dataURI) {
    return dataURIChecker(dataURI, generateDataURI_nonData_PNG());
}

function isDataURI_Img_JPG(dataURI) {
    return dataURIChecker(dataURI, generateDataURI_nonData_JPG());
}

function isDataURI_Img_JPEG(dataURI) {
    return dataURIChecker(dataURI, generateDataURI_nonData_JPEG());
}

function isMediaType_PDF(mediaType) {
    return func_validation.isStringEqual_caseSensitive(mediaType, getMediaType_PDF());
}

function isMediaType_XLSX(mediaType) {
    return func_validation.isStringEqual_caseSensitive(mediaType, getMediaType_XLSX());
}

function isMediaType_CSV(mediaType) {
    return func_validation.isStringEqual_caseSensitive(mediaType, getMediaType_CSV());
}

function isMediaType_Img(mediaType) {
    if (func_validation.isStringTrimNotEmpty(mediaType) && 
        (isMediaType_Img_PNG(mediaType) || 
        isMediaType_Img_JPG(mediaType) ||  
        isMediaType_Img_JPEG(mediaType)) ) return true;
    return false;
}

function isMediaType_Img_PNG(mediaType) {
    return func_validation.isStringEqual_caseSensitive(mediaType, getMediaType_PNG());
}

function isMediaType_Img_JPG(mediaType) {
    return func_validation.isStringEqual_caseSensitive(mediaType, getMediaType_JPG());
}

function isMediaType_Img_JPEG(mediaType) {
    return func_validation.isStringEqual_caseSensitive(mediaType, getMediaType_JPEG());
}

function fileTypeChecker(fileType, mediaType) {
    if (func_validation.isStringTrimNotEmpty(fileType) && 
        ~fileType.indexOf(mediaType)) 
        return true;
    return false;
}

function isFileType_PDF(fileType) {
    return fileTypeChecker(fileType, getMediaType_PDF());
}

function isFileType_XLSX(fileType) {
    return fileTypeChecker(fileType, getMediaType_XLSX());
}

function isFileType_CSV(fileType) {
    return fileTypeChecker(fileType, getMediaType_CSV());
}

function isFileType_Img(fileType) {
    if (func_validation.isStringTrimNotEmpty(fileType) && 
        (isFileType_Img_JPG(fileType) || 
		 isFileType_Img_JPEG(fileType) ||  
		 isFileType_Img_PNG(fileType)) )
        return true;
    return false;
}

function isFileType_Img_PNG(fileType) {
    return fileTypeChecker(fileType, getMediaType_PNG());
}

function isFileType_Img_JPG(fileType) {
    return fileTypeChecker(fileType, getMediaType_JPG());
}

function isFileType_Img_JPEG(fileType) {
    return fileTypeChecker(fileType, getMediaType_JPEG());
}

function getValidatedFileExtension(fileType) {
    if (func_validation.isStringTrimNotEmpty(fileType)) {
        if (isFileType_PDF(fileType)) return getFileExtensionType_PDF();
        else if (isFileType_XLSX(fileType)) return getFileExtensionType_XLSX();
		else if (isFileType_CSV(fileType)) return getFileExtensionType_CSV();
		else if (isFileType_Img_PNG(fileType)) return getFileExtensionType_PNG();
		else if (isFileType_Img_JPG(fileType)) return getFileExtensionType_JPG();
		else if (isFileType_Img_JPEG(fileType)) return getFileExtensionType_JPEG();
	}
	return "";
}
